/* eslint-disable no-unused-vars */
import { useState, createRef, useCallback } from "react";
import { BsSearch } from "react-icons/bs";
import { IconButton, MenuItem, MenuList } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Avatar from "../../assets/Images/avatar.jpg";
import { useMediaQuery } from "react-responsive";
import { Box } from "@mui/system";
import Popover from "@mui/material/Popover";
import { ImgTextDiv, StatusBadge } from "../../pages/student_mgt/stu_mgt.style";
import {
  Icon,
  Input,
  TabContainer,
  TabLinkContainer,
  Search,
  AccountSummaryWrapper,
} from "../../pages/Dashboard/styles/dashboard.style";
import { InputWrapper } from "../../pages/auth/auth.style";
import ErrorService from "../../services/errorService";
import { GetAllDepartments } from "../../services/MySchool";
import { useEffect } from "react";
import Select from "../select/select";
import { NewPagination } from "../pagination_one/NewPaginations";
import { fetchAllStaff } from "../../services/humanResources";
import { useSelector } from "react-redux";
import { updateStatus } from "../../services/user";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";
import TableLoader from "../TableLoader";

const StaffList = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isTab = useMediaQuery({ maxWidth: 992 });
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const { admToken, user } = useSelector((state) => state.auth);
  const [department, setDepartment] = useState([]);

  const accountStatus = [
    { id: 1, name: "Active" },
    { id: 2, name: "Exited" },
    { id: 3, name: "Retired" },
    { id: 4, name: "Saved" },
    { id: 5, name: "Submitted" },
    { id: 6, name: "Rejected" },
  ];

  let initialFilters = {
    schoolId: user.schoolId,
    searchText: "",
    status: 0,
    departmentID: 0,
    pageNumber: 1,
    pageSize: 10,
  };

  const [filters, setFilters] = useState(initialFilters);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedStaff, setSelectedStaff] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [loadingUploading, setLoadingUploading] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handlePopoverOpen = (event, row) => {
    setAnchorEl(event.currentTarget);
    setSelectedItem(row);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const getAllDepartment = useCallback(async () => {
    try {
      setLoading(true);
      const res = await GetAllDepartments(admToken, user.schoolId);

      if (res.status && res.statusCode === 2) {
        setDepartment(res.data);
      } else {
        ErrorService.displayErrorAlert(res.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [admToken, user.schoolId]);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);

      const res = await fetchAllStaff({
        token: admToken,
        departmentId: filters.departmentID,
        status: filters.status,
        searchText: filters.searchText,
        pageSize: filters.pageSize,
        pageNumber: filters.pageNumber,
      });

      if (res.status && res.statusCode === 2) {
        setData(res.data.records);
        setTotalPages(res.data.record.totalPages);
      } else {
        ErrorService.displayErrorAlert(res.data);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  }, [filters, admToken]);

  useEffect(() => {
    getAllDepartment();
  }, [getAllDepartment]);

  useEffect(() => {
    fetchData();
  }, [filters, fetchData]);

  const toggleSelect = (id) => {
    setSelectedStaff((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id],
    );
  };

  const toggleSelectAll = () => {
    const eligible = data
      .filter((i) => i.status === 5 || i.status === 6)
      .map((i) => i.staffId);

    if (!selectAll) {
      setSelectedStaff(eligible);
    } else {
      setSelectedStaff([]);
    }

    setSelectAll(!selectAll);
  };

  const handleSubmit = async (newStatus) => {
    try {
      const payload = {
        status: newStatus,
        staffIds: selectedStaff,
      };

      setLoadingUploading(true);

      const res = await updateStatus(admToken, payload);

      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        setSelectedStaff([]);
        setSelectAll(false);
        fetchData();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false);
    }
  };

  const handleApprove = async (item) => {
    try {
      const payload = {
        status: 1,
        staffIds: [item.staffId],
      };
      setLoadingUploading(true);
      const res = await updateStatus(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        fetchData();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false);
    }
  };

  const handleDelete = async (item) => {
    try {
      const payload = {
        status: 6,
        staffIds: [item.staffId],
      };
      setLoadingUploading(true);
      const res = await updateStatus(admToken, payload);
      if (res.status && res.statusCode === 2) {
        toast.success(res.message);
        fetchData();
      } else {
        toast.error(res.message);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingUploading(false);
    }
  };

  const clearFilters = () => {
    setFilters((prev) => ({
      ...prev,
      searchText: "",
      status: 0,
      departmentID: 0,
      pageNumber: 1,
    }));
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <div>
      {/* {attachModal && (
        <Modal content={content} size={"large"} onClose={setAttachModal} />
      )}
      {assignClassModal && (
        <Modal
          content={assignClassContent}
          size={"large"}
          onClose={setAssignClassModal}
        />
      )} */}
      <TabContainer style={{ marginTop: "1rem" }}>
        <TabLinkContainer bg="#F0E8F1" style={{ position: "relative" }}>
          <div className="flex items-center justify-between w-full mt-6">
            <Input>
              <Icon>
                <BsSearch />
              </Icon>
              <Search
                type="text"
                placeholder="Search by name or Lasmab Number"
                value={filters.searchText}
                onChange={(e) =>
                  setFilters({
                    ...filters,
                    searchText: e.target.value,
                    pageNumber: 1,
                  })
                }
              />
            </Input>
          </div>
          <div className="my-5 flex items-center justify-between w-full">
            <div className="hidden">
              <InputWrapper>
                <label htmlFor="">Department</label>
                <Select
                  title="Department"
                  index="department_name"
                  selected={filters.departmentID}
                  thirdOption="id"
                  options={department}
                  setSelected={(val) => {
                    setFilters({
                      ...filters,
                      departmentID: val.id,
                      pageNumber: 1,
                    });
                  }}
                  style={{ borderRadius: "20px" }}
                />
              </InputWrapper>
            </div>
            <div className="w-[60%]">
              <label htmlFor="">Status</label>
              <Select
                title="Status"
                index="name"
                selected={filters.status}
                thirdOption="id"
                options={accountStatus}
                setSelected={(val) => {
                  setFilters({ ...filters, status: val.id, pageNumber: 1 });
                }}
                sx={{ weight: "100%" }}
              />
            </div>
            <div
              onClick={clearFilters}
              className="text-primary cursor-pointer font-bold py-2 px-5 rounded-lg border border-primary"
            >
              Clear
            </div>
          </div>
        </TabLinkContainer>
        <AccountSummaryWrapper pt="10px">
          <table style={{ borderRadius: "0px" }}>
            {/* TABLE HEAD */}
            <tr
              className="table-head"
              style={{ backgroundColor: "#F0E8F1", color: "black" }}
            >
              <th>
                <input
                  type="checkbox"
                  checked={selectAll}
                  onChange={toggleSelectAll}
                />
              </th>
              <th>Staff Name</th>
              <th>LASMAB Number</th>
              <th>Department</th>
              <th>Status</th>
              <th></th>
            </tr>

            {/* TABLE DATA */}
            {loading ? (
              <tr colSpan={6} align="center">
                <div className="flex items-center justify-center">
                  <TableLoader />
                </div>
              </tr>
            ) : data?.length > 0 ? (
              data?.map((staff) => {
                const staffFullName =
                  `${staff?.firstName} ${staff?.lastName} ${staff?.otherName}`.trim();
                const isSelectable = staff?.status === 5 || staff?.status === 6;

                return (
                  <tr key={staff?.staffId}>
                    {/* Checkbox - only if status is 5 or 6 */}
                    <td>
                      {isSelectable && (
                        <input
                          type="checkbox"
                          checked={selectedStaff.includes(staff.staffId)}
                          onChange={() => toggleSelect(staff.staffId)}
                        />
                      )}
                    </td>

                    {/* Staff Name */}
                    <td>
                      <ImgTextDiv>
                        <img src={Avatar} alt="" />
                        <span>{staffFullName}</span>
                      </ImgTextDiv>
                    </td>

                    <td className="text-center">{staff?.staffId}</td>
                    <td>{staff?.departmentName || "—"}</td>
                    <td>
                      <StatusBadge status={staff?.status}>
                        {accountStatus.find((s) => s.id === staff.status)
                          ?.name || "Saved"}
                      </StatusBadge>
                    </td>

                    <td>
                      <IconButton onClick={(e) => handlePopoverOpen(e, staff)}>
                        <MoreVertIcon />
                      </IconButton>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr colSpan={6} align="center">
                <td>No Available Staff</td>
              </tr>
            )}
          </table>

          {/* APPROVE / DELETE BUTTONS */}
          <div
            style={{
              display: "flex",
              marginTop: "1rem",
              justifyContent: "end",
              padding: "10px 20px",
            }}
          >
            <button
              disabled={selectedStaff.length === 0 || loadingUploading}
              onClick={() => handleSubmit(1)}
              className="rounded-lg min-w-[121px] text-white bg-primary cursor-pointer leading-[2.125rem]! border border-primary font-bold disabled:opacity-50 disabled:cursor-not-allowed py-2"
            >
              Approve
            </button>

            <button
              disabled={selectedStaff.length === 0 || loadingUploading}
              onClick={() => handleSubmit(6)}
              className="rounded-lg min-w-[121px] text-white bg-primary cursor-pointer leading-[2.125rem]! border border-primary font-bold disabled:opacity-50 disabled:cursor-not-allowed py-2"
            >
              Deactivate
            </button>
          </div>
        </AccountSummaryWrapper>
      </TabContainer>
      <div
        style={{
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
        <NewPagination
          pageCount={totalPages}
          currentPage={filters.pageNumber}
          range={3}
          setCurrentPage={(page) =>
            setFilters((prev) => ({ ...prev, pageNumber: page }))
          }
        />
      </div>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            bgcolor: "#671E78",
            color: "#fff",
            fontFamily: "Gilroy-Regular",
            px: 3,
          }}
        >
          <MenuList sx={{ fontFamily: "Gilroy-Regular" }}>
            <Link
              to={`/humanresources/staff-profile/${selectedItem?.staffId}/${selectedItem?.status}`}
            >
              <MenuItem>Edit Profile</MenuItem>
            </Link>
            <MenuItem
              disabled={selectedItem?.status === 1}
              onClick={() => handleApprove(selectedItem)}
            >
              Approve
            </MenuItem>
            <MenuItem
              disabled={selectedItem?.status === 6}
              onClick={() => handleDelete(selectedItem)}
            >
              Delete{" "}
            </MenuItem>
          </MenuList>
        </Box>
      </Popover>
    </div>
  );
};

export default StaffList;
